import { ICreateSendLinkSettingsState } from '../types/createSendLinkSettings';

export const DEFAULT_CREATE_SEND_LINK_SETTINGS_STATE: ICreateSendLinkSettingsState = {
  isExpirationEnabled: false,
  expirationDate: null,
  expirationTimezone: null,
  isOnHoldEnabled: false,
  onHoldUntil: null,
  isPasswordEnabled: false,
  password: '',
  isDomainsEnabled: false,
  allowedDomains: [],
  is2FaEnabled: false,
  twoFaRecipients: null,
};
